<div class="item-wrapper">
  <div class="thumbnail">
    <img [src]="data.src" [alt]="data.id" />
    <div class="progress">
      @if (eventType === 4) {
        <mat-icon class="check">check</mat-icon>
      } @else {
        <mat-progress-spinner
          [mode]="getProgressBarMode()"
          [value]="progress"
          class="prg-bar"
        >
        </mat-progress-spinner>
      }
    </div>
  </div>
</div>
